import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  TextField,
  Typography,
} from '@mui/material';

interface EditarObservacionesFacturaDialogProps {
  open: boolean;
  facturaNumero: number | null;
  comprobanteLabel?: string | null;
  observacionesIniciales?: string;
  loading?: boolean;
  saving?: boolean;
  onClose: () => void;
  onSave: (observaciones: string) => void;
}

const EditarObservacionesFacturaDialog: React.FC<EditarObservacionesFacturaDialogProps> = ({
  open,
  facturaNumero,
  comprobanteLabel,
  observacionesIniciales = '',
  loading = false,
  saving = false,
  onClose,
  onSave,
}) => {
  const [observaciones, setObservaciones] = useState('');
  const [baseline, setBaseline] = useState('');

  useEffect(() => {
    if (!open) return;
    setObservaciones(observacionesIniciales);
    if (!loading) {
      setBaseline(observacionesIniciales);
    }
  }, [open, observacionesIniciales, loading]);

  const hasChanges = observaciones.trim() !== baseline.trim();

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleSubmit = () => {
    if (!hasChanges || loading || saving) return;
    onSave(observaciones);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Editar observaciones</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Factura #{facturaNumero}
          {comprobanteLabel ? ` · ${comprobanteLabel}` : ''}
        </Typography>
        {loading && <LinearProgress sx={{ mb: 2 }} />}
        <TextField
          fullWidth
          multiline
          minRows={4}
          autoFocus
          label="Observaciones"
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          disabled={saving}
          placeholder="Ingrese observaciones para la factura"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || saving || !hasChanges}
        >
          {saving ? 'Guardando…' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarObservacionesFacturaDialog;
